import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

import CarouselMain from '../carousel/CarouselMain.js';
import arrow from '../../assets/icons/arrow-circle-empty-medium.svg';
import arrowContrast from '../../assets/icons/arrow-circle-empty-right-contrast.svg';

const MainPagePblNumbers = ({ clang, data, type }) => {

  const getPBLInNumbersResults = (type) => {
      switch (type) {
          case 'author':
              return 'advanced-results?area=person&q=HEADING%3DCONTAINS_ANYTHING';
          case 'creative-work':
              return 'results?q=*&area=all&tab=creative-work';
          case 'book':
              return 'results?q=*&area=all&tab=records&sorting=accuracy&RECORD_FORM[0]=book';
          case 'review':
              return 'results?q=*&area=all&tab=records&sorting=accuracy&RECORD_TYPE[0]=review';
          case 'movie':
              return 'results?q=*&area=all&tab=records&sorting=accuracy&RECORD_FORM[0]=movie';
          case 'event':
              return 'results?q=*&area=all&tab=event';
          case 'spectacle':
              return 'results?q=*&area=all&tab=records&sorting=accuracy&RECORD_FORM[0]=spectacle&RECORD_TYPE[0]=theatrical-spectacle';
          case 'rtv':
              return 'results?q=*&area=all&tab=records&sorting=accuracy&RECORD_FORM[0]=radio&RECORD_TYPE[0]=play';
          default:
              return;
    }
  }

    const getListItem = (dataItem, index, type) => {
        return  <li key={index} className="main-numbers__item" ref={`item${index}`}>
                    <Link to={`/${getPBLInNumbersResults(dataItem.type)}`}
                     title={`${!!dataItem.count ? numberWithSpaces(dataItem.count) : dataItem.count} ${lang[clang].main_page.types[dataItem.type]}`}>
                        <div className="main-numbers__item__count">
                            {!!dataItem.count ? numberWithSpaces(dataItem.count) : dataItem.count}
                        </div>
                        <div className="main-numbers__item__type">
                            <img className="main-numbers__item__arrow" src={arrow} alt=""/>
                            <img className="main-numbers__item__arrow contrast" src={arrowContrast} alt=""/>
                            {lang[clang].main_page.types[dataItem.type]}
                        </div>
                    </Link>
                </li>;
    };

    return (
        <article className="main-numbers">
            <div className="main-numbers__container">
                <div className="main-numbers__circle"></div>
                <h2 className="main-numbers__header" dangerouslySetInnerHTML={{__html:lang[clang].main_page.numbers}}></h2>
                <div className="main-numbers__carousel">
                    <CarouselMain data={data} getListItem={getListItem}/>
                </div>
            </div>
        </article>
    );
};

MainPagePblNumbers.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(MainPagePblNumbers);



// WEBPACK FOOTER //
// ./src/components/main-page/MainPagePblNumbers.js